// components/UserSelector/index.js
import UserSelector from './UserSelector'
import './UserSelector.css'

export default UserSelector
export { UserSelector }